













import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name      : "StadiumCurator",
  props     : {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    notice  : { type: String, required: true },
  },
  data() {
    return {
      text    : "",
    }
  },
  methods: {
    submit() {
      const params = { estimate_id: this.id, stadium_notice: this.text }
      this.$emit("update:notice", this.text)
      this.$emit("save", params)
    }
  },
  watch: {
    notice(text: string) {
      if (text != "") {
        this.text = text
      }
    }
  }
})
